import { IngredientsUI } from "./IngredientsUI";
import { Product, RuntimeConfig } from "@/types/types";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { useSkinMatchStatus } from "@/hooks/useSkinMatch/useSkinMatch";
import { getEan, EAN_NOT_FOUND } from "@/utils/variant/getEan";
import { recordImpressionByParam } from "@JohnLewisPartnership/experiments-utils";
import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema.ts";
import { useMonetateId } from "@/hooks/useMonetateId/useMonetateId.ts";

function isChanelProduct(product: Product): boolean {
  return product?.brand?.name.toUpperCase() === "CHANEL";
}

type IngredientsProps = {
  product: Product;
  runtimeConfig: RuntimeConfig;
  experiencesRawObject?: Experiences;
};

export function Ingredients({
  product,
  runtimeConfig,
  experiencesRawObject,
}: IngredientsProps) {
  const { variant } = useVariant(product);
  const ean = getEan(variant);
  const { monetateId } = useMonetateId();

  const skinMatchLookUpBaseUrl = runtimeConfig?.skinMatchLookUpBaseUrl;
  const skinMatchLookUpData = useSkinMatchStatus(ean, skinMatchLookUpBaseUrl);

  const dispatchMonetateImpression = () => {
    if (experiencesRawObject?.length) {
      recordImpressionByParam(
        runtimeConfig?.monetateEnvironment,
        experiencesRawObject,
        "pdp-scaffold-hasIngredientsContent",
        "true",
        monetateId,
      );
    }
  };

  if (
    skinMatchLookUpData &&
    skinMatchLookUpData.status == "Done" &&
    skinMatchLookUpData.data.skinMatchStatus
  ) {
    const { id: variantId } = variant;
    const pimProductId = product?.aliases?.pimProductId;
    const isChanel = isChanelProduct(product);
    const skinMatchIngredientBaseUrl =
      runtimeConfig?.skinMatchIngredientBaseUrl;

    if (!variant) return null;
    return (
      ean !== EAN_NOT_FOUND &&
      !isChanel && (
        <IngredientsUI
          ean={ean}
          skinMatchLookUpData={skinMatchLookUpData}
          skinMatchIngredientBaseUrl={skinMatchIngredientBaseUrl}
          pimProductId={pimProductId}
          variantId={variantId}
          dispatchMonetateImpression={dispatchMonetateImpression}
        />
      )
    );
  } else {
    return null;
  }
}
